import React from 'react';
import SubscriptionInfoCard from './SubscriptionInfoCard';
import OrderSummaryCard from '../ShoppingCart/CartPartials/OrderSummaryCard';
import PrimaryButton from '../Buttons/PrimaryButton';

export default class PricingCard extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log("PricingCard", this.props)
		return (
			<div className="PricingCard bg-white">
				<div className="max-w-xl px-10 py-6 shadow border rounded-md">
					<h2 className="text-md md:text-2xl text-center pb-4">
						Why Tralvtax?
					</h2>
					<SubscriptionInfoCard />
					<OrderSummaryCard hasBorder={false} />
					<div className="grid justify-items-stretch">
						<PrimaryButton label="Buy now" url={this.props.url} />
					</div>
				</div>
			</div>
		);
	}
}
